import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-primary" }, "Current", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-primary" }, "Unfulfilled", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-warning" }, "Hold", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-warning" }, "InReview", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-error" }, "Rejected", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-error" }, "Cancel", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "Approved", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "InTransit", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "InProduction", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "Partially Fulfilled", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "Fulfilled", -1)
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Actions", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-double" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  Verify address ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Approve orders ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plane-slash" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("  Cancel ship ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("  Reject orders ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  Cancel orders ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-car" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("  Can Shiping Area ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play-circle" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("  Unhold orders ")
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { hidden: "" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Display count by status ")
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Variant:", -1)
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Code:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Quantity:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Cost:", -1)
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SKU:", -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tracking:", -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tracking:", -1)
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Custom Texts:")
], -1)
const _hoisted_51 = { class: "ml-2" }
const _hoisted_52 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_53 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { key: 4 }
const _hoisted_57 = { key: 5 }
const _hoisted_58 = { key: 6 }
const _hoisted_59 = { key: 7 }
const _hoisted_60 = {
  key: 8,
  class: "font-bold"
}
const _hoisted_61 = {
  key: 9,
  class: "font-bold"
}
const _hoisted_62 = { key: 10 }
const _hoisted_63 = { key: 11 }
const _hoisted_64 = { key: 12 }
const _hoisted_65 = { key: 13 }
const _hoisted_66 = { key: 14 }
const _hoisted_67 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataFilterArea = _resolveComponent("DataFilterArea")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_OrderImagePreview = _resolveComponent("OrderImagePreview")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_ColumnTitle = _resolveComponent("ColumnTitle")!
  const _component_ColumnCustomer = _resolveComponent("ColumnCustomer")!
  const _component_ColumnAddress = _resolveComponent("ColumnAddress")!
  const _component_ColumnStatus = _resolveComponent("ColumnStatus")!
  const _component_ColumnSource = _resolveComponent("ColumnSource")!
  const _component_ColumnArtwork = _resolveComponent("ColumnArtwork")!
  const _component_ColumnExport = _resolveComponent("ColumnExport")!
  const _component_ColumnSellerTeam = _resolveComponent("ColumnSellerTeam")!
  const _component_ColumnTracking = _resolveComponent("ColumnTracking")!
  const _component_ColumnActions = _resolveComponent("ColumnActions")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_TicketListDialog = _resolveComponent("TicketListDialog")!
  const _component_RequestSellerDialog = _resolveComponent("RequestSellerDialog")!
  const _component_AgencyNoteDialog = _resolveComponent("AgencyNoteDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionImport: _ctx.showExportHistory,
    onActionExport: _ctx.confirmExportOrder,
    onActionReport: _ctx.reportOrders,
    loadingExport: _ctx.data.isLoadingExport,
    loadingImport: _ctx.data.isLoadingImport,
    loadingOtherButton1: _ctx.data.isLoadingExportDropship
  }), {
    default: _withCtx(() => [
      _createVNode(_component_DataFilterArea, {
        params: _ctx.params,
        "data-filter": _ctx.data,
        "is-allow-import-export": _ctx.isAllowImportExport,
        "is-order-exporter": _ctx.isOrderExporter,
        onChangeParamsOrder: _ctx.onFilterCallback,
        onChangeDate: _ctx.onChangeDate
      }, null, 8, ["params", "data-filter", "is-allow-import-export", "is-order-exporter", "onChangeParamsOrder", "onChangeDate"]),
      (_ctx.isDisplayCountOrderByStatus)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            hidden: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "mt-3 text-xs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    class: "margin-top",
                    title: "",
                    column: 24,
                    size: _ctx.small,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_1
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, { size: "small" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.state.total ? _ctx.state.total : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_2
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Unfulfilled
                  ? _ctx.countOrderByStatus?.Unfulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_3
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Hold ? _ctx.countOrderByStatus?.Hold : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_4
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.InReview ? _ctx.countOrderByStatus?.InReview : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_5
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Rejected ? _ctx.countOrderByStatus?.Rejected : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Cancel ? _ctx.countOrderByStatus?.Cancel : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_7
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Approved ? _ctx.countOrderByStatus?.Approved : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_8
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.InTransit
                  ? _ctx.countOrderByStatus?.InTransit
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_9
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.InProduction
                  ? _ctx.countOrderByStatus?.InProduction
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.PartiallyFulfilled
                  ? _ctx.countOrderByStatus?.PartiallyFulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Fulfilled
                  ? _ctx.countOrderByStatus?.Fulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isAllowActions)
        ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    (
              _ctx.state.multipleSelection.length !== 0 &&
              _ctx.userInfo.userType === _ctx.UserTypes.AGENCY
            )
                      ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOpenMessageWarningAction('verify-address')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_14,
                                    _hoisted_15
                                  ]),
                                  _: 1
                                }),
                                (_ctx.checkSelectOrderForAction('approve'))
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 0,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenMessageWarningAction('approve')))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_16,
                                        _hoisted_17
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.checkSelectOrderForAction('cancel-ship'))
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 1,
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenMessageWarningAction('cancel-ship')))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_18,
                                        _hoisted_19
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.checkSelectOrderForAction('reject'))
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 2,
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenMessageWarningAction('reject')))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_20,
                                        _hoisted_21
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.checkSelectOrderForAction('cancel'))
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 3,
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onOpenMessageWarningAction('cancel')))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_22,
                                        _hoisted_23
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.checkSelectOrderForAction('shipping-area'))
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 4,
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onOpenMessageWarningAction('shipping-area')))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_24,
                                        _hoisted_25
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.checkSelectOrderForAction('unhold'))
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 5,
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOpenMessageWarningAction('unhold')))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_26,
                                        _hoisted_27
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.multipleSelection.length) + " selecteds ", 1),
                                _createVNode(_component_el_divider, { direction: "vertical" }),
                                _hoisted_13,
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_arrow_down)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28)),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_el_checkbox, {
                        "v-model": _ctx.isDisplayCountOrderByStatus,
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeDisplayCount()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["v-model"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.state.orders,
        "element-loading-text": "Loading...",
        lazy: true,
        onSelectionChange: _ctx.handleSelectionChange,
        style: {"width":"100%"},
        stripe: "",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "40"
          }),
          (!_ctx.isOrderExporter)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "expand"
              }, {
                default: _withCtx((props) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items.filter(
            (i) => i.sku !== 'Tip'
          ), (item, iItem) => {
                    return (_openBlock(), _createBlock(_component_el_row, {
                      class: "px-5 py-3",
                      gutter: 20,
                      key: iItem
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 6,
                          class: "pl-10"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_OrderImagePreview, {
                              item: item,
                              disableEdit: true
                            }, null, 8, ["item"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 14 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_31, [
                                  (item.productId)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                                        _createVNode(_component_router_link, {
                                          to: {
                        name: 's.product-detail',
                        params: { id: item.productId },
                      },
                                          class: "text-primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.itemName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(item.itemName), 1))
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    (item.variantTitle)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                          _hoisted_35,
                                          _createTextVNode(" " + _toDisplayString(item.variantTitle), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.catalogCode)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                          _hoisted_37,
                                          _createTextVNode(" " + _toDisplayString(item.catalogCode), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", null, [
                                      _hoisted_38,
                                      _createTextVNode(" " + _toDisplayString(item.quantity), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_39,
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatterDollars(item.sellerAmount)), 1)
                                    ]),
                                    (item.sku && item.sku != 'SKU')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                                          _hoisted_41,
                                          _createTextVNode(" " + _toDisplayString(item.sku), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    (item.trackingNumber)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                                          _hoisted_43,
                                          _createTextVNode(" " + _toDisplayString(item.trackingNumber), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.carrier)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                                          _hoisted_45,
                                          _createTextVNode(" " + _toDisplayString(item.carrier), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    (item.trackingNumber)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                                          _hoisted_47,
                                          _createTextVNode(" " + _toDisplayString(item.trackingNumber), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.carrier)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                                          _hoisted_49,
                                          _createTextVNode(" " + _toDisplayString(item.carrier), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                (item.customTexts)
                                  ? (_openBlock(), _createBlock(_component_el_col, {
                                      key: 0,
                                      span: 24,
                                      class: "flex"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_50,
                                        _createElementVNode("div", _hoisted_51, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.customTexts, (customText, index) => {
                                            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(customText.display_key) + " : " + _toDisplayString(customText.display_value), 1))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isOrderExporter)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                label: "",
                width: "40",
                "class-name": "cellTicket"
              }, {
                default: _withCtx((scope) => [
                  (scope.row && scope.row.count && scope.row.count > 0)
                    ? (_openBlock(), _createBlock(_component_el_badge, {
                        key: 0,
                        value: scope.row.count
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            underline: false,
                            type: "primary",
                            onClick: ($event: any) => (_ctx.onViewTicketList(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: "20" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Message)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    : (_openBlock(), _createBlock(_component_el_link, {
                        key: 1,
                        underline: false,
                        type: "primary",
                        onClick: ($event: any) => (_ctx.onViewTicketList(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: "20" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Message)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: column.title,
              width: column.width,
              "min-width": column.minWidth,
              props: column.dataIndex,
              align: column.align
            }, {
              default: _withCtx((scope) => [
                (column.title === 'Order')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createVNode(_component_ColumnTitle, {
                        scope: scope,
                        "is-order-exporter": _ctx.isOrderExporter
                      }, null, 8, ["scope", "is-order-exporter"])
                    ]))
                  : (column.dataIndex === 'fullName')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createVNode(_component_ColumnCustomer, {
                          scope: scope,
                          state: _ctx.state
                        }, null, 8, ["scope", "state"])
                      ]))
                    : (column.dataIndex === 'addressValid')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createVNode(_component_ColumnAddress, {
                            scope: scope,
                            column: column,
                            state: _ctx.state
                          }, null, 8, ["scope", "column", "state"])
                        ]))
                      : (column.dataIndex === 'status')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createVNode(_component_ColumnStatus, { scope: scope }, null, 8, ["scope"])
                          ]))
                        : (column.dataIndex === 'source')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createVNode(_component_ColumnSource, { scope: scope }, null, 8, ["scope"])
                            ]))
                          : (column.dataIndex === 'orderType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createElementVNode("p", null, [
                                  _createVNode(_component_el_tag, {
                                    effect: "dark",
                                    class: "rounded",
                                    size: "small",
                                    type: 
                    scope.row?.isFK === true
                      ? 'warning'
                      : scope.row?.isDropship === true
                      ? ''
                      : 'info'
                  
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.orderTypeComputed(scope.row)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_el_tag, {
                                    class: "rounded",
                                    size: "small",
                                    type: scope.row?.isUseLattePayment === true ? '' : 'info'
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.row?.isUseLattePayment === true
                      ? 'LatteX Payment'
                      : 'Seller Payment'), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type"])
                                ])
                              ]))
                            : (column.dataIndex === 'designStatus')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  _createVNode(_component_ColumnArtwork, { scope: scope }, null, 8, ["scope"])
                                ]))
                              : (column.dataIndex === 'exportStatus')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createVNode(_component_ColumnExport, { scope: scope }, null, 8, ["scope"])
                                  ]))
                                : (column.dataIndex === 'sellerAmount')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex])), 1))
                                  : (column.dataIndex === 'grandTotal')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex])), 1))
                                    : (column.dataIndex === 'sellerTeam')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          (scope?.row?.sellerTeam?.name)
                                            ? (_openBlock(), _createBlock(_component_ColumnSellerTeam, {
                                                key: 0,
                                                scope: scope,
                                                sellerTeam: scope?.row?.sellerTeam,
                                                column: column,
                                                data: _ctx.data.sellerTeams
                                              }, null, 8, ["scope", "sellerTeam", "column", "data"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (column.dataIndex === 'trackingNumber')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            _createVNode(_component_ColumnTracking, { scope: scope }, null, 8, ["scope"])
                                          ]))
                                        : (column.dataIndex === 'createdDate')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.formatDateTime(scope.row[column.dataIndex])), 1))
                                          : (column.dataIndex === 'actions' && _ctx.isAllowActions)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                _createVNode(_component_ColumnActions, {
                                                  scope: scope,
                                                  userInfo: _ctx.userInfo,
                                                  onOnSubmitApprove: _ctx.onSubmitApprove,
                                                  onOnSubmitCancelShip: _ctx.onSubmitCancelShip,
                                                  onOnSubmitReject: _ctx.onSubmitReject,
                                                  onOnClickRequestSeller: _ctx.onClickRequestSeller,
                                                  onOnClickAgencyNote: _ctx.onClickAgencyNote,
                                                  onOnLoadOrders: _ctx.onLoadOrders
                                                }, null, 8, ["scope", "userInfo", "onOnSubmitApprove", "onOnSubmitCancelShip", "onOnSubmitReject", "onOnClickRequestSeller", "onOnClickAgencyNote", "onOnLoadOrders"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(scope.row[column.dataIndex]), 1))
              ]),
              _: 2
            }, 1032, ["label", "width", "min-width", "props", "align"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "onSelectionChange"]), [
        [_directive_loading, _ctx.data.isLoading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.state.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.data.showExportHistory,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.showExportHistory) = $event)),
        title: "Export History",
        width: "60%",
        top: "6vh"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table, {
                    data: _ctx.data.dataHistories.histories,
                    style: {"height":"600px","overflow":"auto"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        property: "exportDate",
                        label: "Created",
                        "min-width": 10
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.formatTime(scope.row.exportDate)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "fileName",
                        label: "File name",
                        "min-width": 25
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.fileName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "Created by",
                        "min-width": 10
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.agency.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Action",
                        "min-width": 10
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("a", {
                            href: scope.row.filePath,
                            target: "_blank",
                            class: "text-blue-600"
                          }, " Download ", 8, _hoisted_67)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_pagination, {
                    total: _ctx.data.dataHistories.total,
                    pagination: _ctx.data.dataHistories.params.page,
                    "onUpdate:pagination": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.dataHistories.params.page) = $event)),
                    limit: _ctx.data.dataHistories.params.limit,
                    "onUpdate:limit": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.dataHistories.params.limit) = $event))
                  }, null, 8, ["total", "pagination", "limit"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_TicketListDialog, { ref: "ticketListDialog" }, null, 512),
      _createVNode(_component_RequestSellerDialog, {
        ref: "requestSellerDialog",
        onOnAfterResquestSeller: _ctx.onAfterResquestSeller
      }, null, 8, ["onOnAfterResquestSeller"]),
      _createVNode(_component_AgencyNoteDialog, {
        ref: "agencyNoteDialog",
        onOnAfterAgencyNote: _ctx.onAfterAgencyNote
      }, null, 8, ["onOnAfterAgencyNote"])
    ]),
    _: 1
  }, 16, ["onActionImport", "onActionExport", "onActionReport", "loadingExport", "loadingImport", "loadingOtherButton1"]))
}